import React from 'react'
import { Box } from '@mui/material'
import BusinessStatsRisks from '../BusinessStatsRisks'


const sx = {
  title: {
    color: '#0076C5',
  },
  propertyList: {
    display: 'flex',
    flexDirection: 'row'
  },
  propertyListCol: {
    display: 'flex',
    flexDirection: 'column'
  },
  propertyGroup: {
    marginRight: theme => theme.spacing(0)
  },
  propertyGroup3: {
    marginRight: theme => theme.spacing(3)
  },
  propertyLine: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme => theme.spacing(1.5),
  },
}

const BusinessStats2 = props => {
  const { model } = props

  return (
    <Box>
      <Box sx={props.small ? sx.propertyListCol : sx.propertyList}>
        <Box sx={props.small ? sx.propertyGroup : sx.propertyGroup3}>
          <Box sx={sx.propertyLine}>
            <BusinessStatsRisks riskClass={model.crc} riskScore={model.crs} />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default BusinessStats2
